{
  "Approve": "Approve",
  "DeleteReminder": "Delete reminder",
  "DismissAlert": "Dismiss",
  "DismissReminder": "Dismiss reminder",
  "Earlier": "EARLIER",
  "EditReminder": "Edit reminder",
  "High": "High",
  "MarkAllAsRead": "Mark all as read",
  "Reject": "Reject",
  "RemindMe15Min": "Remind me in 15 minutes",
  "RemindMe5Min": "Remind me in 5 minutes",
  "RemindMe60Min": "Remind me in an hour",
  "RemindMeTomorrow": "Remind me tomorrow",
  "Snooze": "Remind me",
  "markAsRead": "Mark as read",
  "markAsUnread": "Mark as unread",
  "noNotifications": "You will receive important information about our products, your collaboration with fellow users, and other relevant updates",
  "noNotificationsTitle": "Your Notifications will appear here"
} 
